import { Injectable } from '@angular/core';
import { isEqual, isNil } from 'lodash';
import { Context } from 'ag-grid-community/dist/lib/context/context';

/**
 * This service is used to manage the focused grid context across multiple ag-Grid instances.
 * It helps to ensure that only one grid has focus at a time, which is important for keyboard navigation.
 */
@Injectable()
export class AgGridService {
  private _focusedGridContext: Context = null;

  public get focusedGridContext(): Context {
    return this._focusedGridContext;
  }

  public updateFocusedGridContext(context: Context): void {
    this._focusedGridContext = context;
  }

  public isSameAsFocusedGridContext(context: Context): boolean {
    if (isNil(this._focusedGridContext)) {
      this.updateFocusedGridContext(context);

      return true;
    }

    return isEqual(this._focusedGridContext, context);
  }
}
